var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[_vm.$style.toggle] = true, _obj[_vm.$style.isTrue] = _vm.value, _obj ),attrs:{"tabindex":"0"},on:{"click":_vm.toggle,"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.toggle($event)}}},[_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }